import StepTipsPanel from '@/components/company/StepTipsPanel';

export default function TrainTipsPanel({ videoLink, tips }: Readonly<{ videoLink?: string; tips?: string }>) {
  return <StepTipsPanel tips={tips} videoLink={videoLink} />;
}
